.panel {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 24px;
  min-width: 0;
}

.heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 18px;
}

.headLabel {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
}

.total {
  font-size: 0.88rem;
  font-variant-numeric: tabular-nums;
  color: var(--muted);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.row {
  display: grid;
  grid-template-columns: 118px 1fr 92px;
  align-items: center;
  gap: 12px;
}

.name {
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
}

.barTrack {
  height: 6px;
  background: var(--surface-2);
  border-radius: 999px;
  overflow: hidden;
}

.barFill {
  height: 100%;
  border-radius: inherit;
  background: var(--amber);
  opacity: 0.7;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat {
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
  color: var(--muted);
  text-align: right;
  white-space: nowrap;
}

.empty {
  display: grid;
  place-items: center;
  min-height: 80px;
  font-size: 0.9rem;
  color: var(--muted);
}
